import { Client } from 'modules/Client/Client'
import { Compartment } from 'modules/Compartment/Compartment'
import { Device } from 'modules/Device/Device'
import { Equipment } from 'modules/Equipment/Equipment'
import { Project } from 'modules/Project/Project'
import { Site } from 'modules/Site/Site'
import { Tank } from 'modules/Tank/Tank'
import { Transaction } from 'modules/Transaction/Transaction'
import { Model } from 'pinia-orm'

import { Attr, BelongsTo, Uid } from 'pinia-orm/dist/decorators'

export class LevelNode extends Model {
  static override entity = 'level_nodes'

  // Fields
  @Uid() declare id: string

  @Attr() declare hardware_transaction_id: null | string
  @Attr() declare time: null | number | string
  @Attr() declare hardware_datetime_tz: null | string
  @Attr() declare faults: null | string
  @Attr() declare sensor_milliamps: null | number
  @Attr() declare sensor_adc: null | number
  @Attr() declare height_mm: null | number
  @Attr() declare battery_mv: null | number
  @Attr() declare power_mv: null | number
  @Attr() declare flow_rate: null | number
  @Attr() declare pulse: null | number
  @Attr() declare volume_ml: null | number
  @Attr() declare rssi: null | number
  @Attr() declare tank_level_liters: null | number

  @Attr() declare transaction_id: null | string
  @Attr() declare equipment_id: null | string
  @Attr() declare compartment_id: null | string
  @Attr() declare client_id: null | string
  @Attr() declare site_id: null | string
  @Attr() declare device_id: null | string
  @Attr() declare project_id: null | string
  @Attr() declare tank_id: null | string

  // Relationships
  @BelongsTo(() => Transaction, 'transaction_id') declare transaction: Transaction | null
  @BelongsTo(() => Equipment, 'equipment_id') declare equipment: Equipment | null
  @BelongsTo(() => Compartment, 'compartment_id') declare compartment: Compartment | null
  @BelongsTo(() => Client, 'client_id') declare client: Client | null
  @BelongsTo(() => Site, 'site_id') declare site: Site | null
  @BelongsTo(() => Device, 'device_id') declare device: Device | null
  @BelongsTo(() => Project, 'project_id') declare project: Project | null
  @BelongsTo(() => Tank, 'tank_id') declare tank: Tank | null
}
